<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb"/>
    <div>
      <div class="desc">
        <h4 style="margin:20px 0;text-align:start;border-left:7px solid #1362FF;padding-left:3px">{{ mainData.enterpriseName }}</h4>
        <div style="display:flex">
        <button-export
        :href="exportUrl"
        :beforeDownload="beforeDownload"
        v-if="permissionCodes.indexOf('013029001') !== -1"
        download="download.xls"
        value="导出"/>
        <button-confirm value="返回"  @confirm="goBack" style="width:92px;font-size:16px"/>
        </div>
      </div>

      <div class="contract-box">
        <div class="item-box">
          <div class="num">{{ mainData.rentCount }}</div>
          <div>租金账单数量</div>
        </div>
        <div class="item-box">
          <div class="num">{{ mainData.paidRentCount }}</div>
          <div>已支付租金账单</div>
        </div>
        <div class="item-box">
          <div class="num">{{ mainData.totalReceivable }}</div>
          <div>应收总金额(元)</div>
        </div>
        <div class="item-box">
          <div class="num">{{ mainData.amountPaid }}</div>
          <div>已支付金额(元)</div>
        </div>
        <div class="item-box">
          <div class="num">{{ mainData.surrenderTotalAmount }}</div>
          <div>退租金额(元)</div>
        </div>
        <div class="item-box">
          <div class="num">{{ mainData.realTotalAmount }}</div>
          <div>实收总金额(元)</div>
        </div>
      </div>
    </div>
<!--    <div class="divide"></div>-->

      <el-tabs v-model="billTabName" @tab-click="billTabClick" style="margin-top:50px;padding:0 20px;">
        <el-tab-pane label="租金账单明细" name="rentBill">
          <table-main v-if="billTabName == 'rentBill'" :tableHead="tableRentHead" :tableData="tableData" :selection="false" :total="total" :pageNum="pageNum" :pageSize="pageSize" @changePagination="changePagination" :hasOperation="false"/>
        </el-tab-pane>
        <el-tab-pane label="物业账单明细" name="propertyBill">
          <table-main v-if="billTabName == 'propertyBill'" :tableHead="tableRentHead" :tableData="tableData" :selection="false" :total="total" :pageNum="pageNum" :pageSize="pageSize" @changePagination="changePagination" :hasOperation="false"/>
        </el-tab-pane>
        <el-tab-pane label="能耗账单明细" name="energyBill">
          <table-main v-if="billTabName == 'energyBill'" :tableHead="tableEnergyHead" :tableData="tableData" :selection="false" :total="total" :pageNum="pageNum" :pageSize="pageSize" @changePagination="changePagination" :hasOperation="false"/>
        </el-tab-pane>
        <el-tab-pane label="其他账单明细" name="otherBill">
          <table-main v-if="billTabName == 'otherBill'" :tableHead="tableOtherHead" :tableData="tableData" :selection="false" :total="total" :pageNum="pageNum" :pageSize="pageSize" @changePagination="changePagination" :hasOperation="false"/>
        </el-tab-pane>
        <el-tab-pane label="退租账单明细" name="offBill">
          <table-main v-if="billTabName == 'offBill'" :tableHead="tableOffHead" :tableData="tableData" :selection="false" :total="total" :pageNum="pageNum" :pageSize="pageSize" @changePagination="changePagination" :hasOperation="false"/>
        </el-tab-pane>
      </el-tabs>

  </div>
</template>

<script>
import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
import ButtonAdd from '../../../components/Button/ButtonAdd'
import ButtonDelete from '../../../components/Button/ButtonDelete'
import ButtonExport from '../../../components/common/buttons/button-export'
import ButtonUpload from '../../../components/common/buttons/button-upload'
import InputSearch from '../../../components/Input/InputSearch'
import InputSelect from '../../../components/Input/InputSelect'
import TableMain from '../../../components/Table/TableMain'
import {api} from '../../api/Finance'
import {errorHandler} from '../../../utils/errorHandler'
import {nError, nSuccess} from '../../../utils/notice'
import {bus} from '../../../utils/bus'
import ButtonCancel from '../../../components/Button/ButtonCancel'
import ButtonConfirm from '../../../components/Button/ButtonConfirm'

export default {
  components: {
    ButtonCancel,
    TableMain,
    InputSelect,
    InputSearch,
    ButtonUpload,
    ButtonExport,
    ButtonDelete,
    ButtonAdd,
    ButtonConfirm,
    Breadcrumb},
  name: 'tenant-bill',
  data () {
    return{
      breadcrumb: [{
        value: '智慧财务',
        name: 'finance-over-view'
      }, {
        value: '租户账单'
      }],

      billTabName: "rentBill",
      pageSize: 10,
      pageNum: 1,
      tableData:[],
      total:0,

      tableRentHead:[
        {
          prop:"contractCode",
          label:"合同编号"
        },
        {
          prop:"duration",
          label:"区间"
        },
        {
          prop:"feeType",
          label:"费用类型"
        },
        {
          prop:"payDeadline",
          label:"付款日"
        },
        {
          prop:"unitpriceText",
          label:"最终单价"
        },
        {
          prop:"payMoney",
          label:"应付金额(元)"
        },
        {
          prop:"payStatusText",
          label:"收款状态"
        },
      ],
      tableOtherHead:[
        {
          prop:"feeType",
          label:"费用类型"
        },
        {
          prop:"payMoney",
          label:"应付金额(元)"
        },
        {
          prop:"payMoney",
          label:"实收金额(元)"
        },
        {
          prop:"payTime",
          label:"收款日期"
        },
        {
          prop:"payStatusText",
          label:"收款状态"
        },
      ],
      tableOffHead:[
      {
        prop:"feeType",
        label:"费用类型"
      },
      {
        prop:"dueIncomeOrBackAmount",
        label:"应收/退金额(元)"
      },
      {
        prop:"realIncomeOrBackAmount",
        label:"实收/退金额(元)"
      },
      {
        prop:"date",
        label:"收/退款日期"
      },
      {
        prop:"statusText",
        label:"收/退款状态"
      },
    ],
      tableEnergyHead:[
        {
          prop:"feeType",
          label:"费用类型"
        },
        {
          prop:"payMoney",
          label:"应付金额(元)"
        },
        {
          prop:"realMoney",
          label:"实收金额(元)"
        },
      ],

      mainData:{},
      exportUrl: "",
    }
  },
  created() {
    this.permissionCodes = bus.global.permissionCodes;
    this.mainData = this.$route.params;
    this.getPage()
  },
  methods: {
    beforeDownload() {
      this.exportUrl = `${api.exportItemDetail}?yq-app-code=${bus.global.yqCode}&kj-type=gy&enterpriseCode=${this.mainData.enterpriseCode}&token=${bus.global.token}`;
    },
    billTabClick() {
      this.pageNum = 1;
      this.pageSize = 10;
      this.getPage();
    },

    changePagination(data) {
      this.pageNum = data[0];
      this.pageSize = data[1];
      this.getPage();
    },

    getPage() {
      let url = "";
      let reqData ={};
      if (this.billTabName === "rentBill") {
        url = api.getRentBillPage;
        reqData.feeType="租金"
      } else if(this.billTabName === "propertyBill") {
        url = api.getRentBillPage;
        reqData.feeType="物业"
      } else if(this.billTabName === "energyBill") {
        url = api.getEnergyBillPage;
      } else if(this.billTabName === "otherBill") {
        url = api.getRentBillPage;
        reqData.feeType="其他"
      } else if(this.billTabName === "offBill") {
        url = api.getSurrenderBillPagePage;
      }
      reqData.enterpriseCode=this.mainData.enterpriseCode
      reqData.pageNum=this.pageNum
      reqData.pageSize=this.pageSize
      this.$axios
        .post(url, reqData)
        .then((res) => {
          if (res.data.retCode === 1) {
            let data = res.data.data;
            data.list.map(v=>{
              if(v.payStatus=='0'){
                v.payStatusText='未缴费'
              }else if (v.payStatus=='1'){
                v.payStatusText='已缴费'
              }else if (v.payStatus=='2'){
                v.payStatusText='部分缴费'
              }else if (v.payStatus=='3'){
                v.payStatusText='已缴费--已变更'
              }else if (v.payStatus=='4'){
                v.payStatusText='未缴费--已变更'
              }else if (v.payStatus=='5'){
                v.payStatusText='已退款'
              }else if (v.payStatus=='6'){
                v.payStatusText='审批中'
              }
              if(v.priceUnit=='1'){
                v.priceUnitText='元/m*天'
              }else if(v.priceUnit=='2'){
                v.priceUnitText='元/m*月'
              }else if(v.priceUnit=='3'){
                v.priceUnitText='元/月'
              }else if(v.priceUnit=='4'){
                v.priceUnitText='元/天'
              }else{
                v.priceUnitText='-'
              }
              if(!v.price){
                v.price='-'
              }
              v.unitpriceText=v.price+v.priceUnitText

              if(v.status=='1'){
                v.statusText='未退款'
              }else if(v.status=='2'){
                v.statusText='已退款'
              }else if(v.status=='3'){
                v.statusText='未收款'
              }else if(v.status=='4'){
                v.statusText='已收款'
              }
            })
            this.tableData = data.list;
            console.log(this.tableData)
            this.total=data.total;
          }
        })
        .catch(errorHandler("获取数据失败"));
    },

    goBack(){
      this.$router.go(-1);
    }

  }
}
</script>

<style lang="less">
.desc{
  display: flex;
  justify-content:space-between;
  align-items:center;
  padding:5px;
}

.divide{
  height:20px;
  margin:10px 0;
  background:#F0F0F7;
}

.finance-over-view-line {
  height: 260px;
  display: flex;
  justify-content: space-between;
  margin: 40px 0 20px 0;
  padding-bottom: 10px;
  .finance-over-view-line-left-box {
    width: 66%;
  }
  .finance-over-view-line-right-box {
    width: 33%;
  }
  .finance-over-view-line-tab-item {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .finance-person-count-all {
    display: flex;
    justify-content: center;
    flex-direction: column;
    .finance-person-count-box {
      width: 160px;
      height: 120px;
      padding: 20px 10px;
      border-right: 1px solid #eee;
      border-bottom: 1px solid #eee;
      color: #666666;
      display: flex;
      justify-content: center;
      flex-direction: column;
      .finance-person-count {
        font-size: 32px;
        font-weight: 500;
      }
      .finance-person-tip {
        font-size: 14px;
      }
    }
  }
  .finance-over-view-line-left {
    width: 49%;
    padding: 10px 10px;
    border: 1px solid #eeeeee;
    border-radius: 10px;
    display: flex;
    justify-content: space-between;
    overflow: hidden;
  }
  .finance-over-view-line-right {
    width: 49%;
    padding: 10px 10px;
    border: 1px solid #eeeeee;
    border-radius: 10px;
    overflow: hidden;
    display: flex;
    justify-content: space-between;
  }
}
.el-table {
  thead {
    th {
      padding: 6px 0;
      text-align: center;
      color: #666666;
      background-color: #eff1f5;
    }
  }
  tbody {
    td {
      padding: 6px 0;
      text-align: center;
    }
  }
}
.contract-box{
  display: flex;
  width:100%;
  .item-box{
    flex: 1;
    height: 104px;
    width: 240px;
    margin:0 10px;
    box-shadow: 0px 0px 10px rgba(92, 92, 92, 0.16);
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    align-items: center;
    font-weight: bold;
    .num{
      font-size: 28px;
      font-family: D-DIN;
      font-weight: bold;
      color: #1362FF;
      opacity: 1;
    }
  }
}

.el-table::before{
  height:0;
}
</style>



// WEBPACK FOOTER //
// src/view/Finance/tenantBill/tenantBill.vue